import React from 'react';
import { redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../components/utilities/Button';
import { asyncUnsetAuthUser } from '../states/authUser/action';

export default function MyProfilePage() {
  const { authUser } = useSelector((state) => state);
  const dispatch = useDispatch();

  const onLogout = () => {
    redirect('/');
    dispatch(asyncUnsetAuthUser());
  };

  return (
    <section>
      <h1 className="text-2xl font-bold mb-8">My Profile</h1>
      <div className="flex flex-col md:flex-row gap-8 justify-between">
        <div className="flex gap-x-8 items-center">
          <img
            src={authUser.avatar}
            alt={authUser.name}
            className="rounded-full"
          />
          <div>
            <p className="font-bold text-lg">{authUser.name}</p>
            <p className="text-zinc-600 dark:text-zinc-400">{authUser.email}</p>
          </div>
        </div>
        <Button label="Logout" onClick={() => onLogout()} className="mt-8" />
      </div>
    </section>
  );
}
